import { Pipe } from '@angular/core';
import { isArray } from '../utils/utils';
var ReversePipe = (function () {
    function ReversePipe() {
    }
    ReversePipe.prototype.transform = function (input) {
        if (!isArray(input)) {
            return input;
        }
        return input.slice().reverse();
    };
    return ReversePipe;
}());
export { ReversePipe };
ReversePipe.decorators = [
    { type: Pipe, args: [{
                name: 'reverse'
            },] },
];
/** @nocollapse */
ReversePipe.ctorParameters = function () { return []; };
//# sourceMappingURL=reverse.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/array/reverse.pipe.js
// module id = 245
// module chunks = 103